module.exports = __webpack_public_path__ + "img/part1.59468c5.png";